import React, { useState, useRef, useEffect } from "react";
import { camelToTitle, generateColumnClass } from "../../Utility";
import SearchInput from "./SearchInput";

const SelectOption = ({
                          name,
                          value,
                          options,
                          error,
                          label,
                          onChange,
                          onBlur,
                          columns,
                          inline,
                          enums,
                          isSearch = false,
                          disabled = false,
                          searchPlaceholder = "Search..."
                      }) => {
    const [searchText, setSearchText] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const columnClass = generateColumnClass(columns);
    const className = `${inline ? "d-flex flex-wrap " : ""}col-12${columnClass}`;

    // Close dropdown if clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Filtered options
    const filteredOptions = Object.keys(options).filter((key) => {
        const labelText = enums ? camelToTitle(key) : options[key];
        return labelText.toLowerCase().includes(searchText.toLowerCase());
    });

    const handleSelect = (optionValue) => {
        onChange({
            target: { name, value: optionValue }
        });
        setIsOpen(false);
        setSearchText(""); // Reset search after select
    };

    return (
        <div className={className} ref={dropdownRef}>
            {label && (
                <label
                    className={`form-label opacity-75${
                        inline ? " mb-0 py-2 col-12 col-md-4" : ""
                    }`}
                    htmlFor={name}
                >
                    {label}
                </label>
            )}

            <div className={`position-relative custom-select${inline ? " col" : ""}`}>
                <div
                    tabIndex={disabled ? -1 : 0}
                    className={`form-select d-flex align-items-center justify-content-between fs-md ${disabled ? "text-muted" : ""}`}
                    onClick={() => !disabled && setIsOpen((prev) => !prev)}
                    style={{
                        cursor: disabled ? "not-allowed" : "pointer",
                        backgroundColor: disabled ? "var(--bs-secondary-bg)" : "",
                        color: disabled ? "#6c757d" : ""
                    }}
                >
                    {value !== null && value !== undefined
                        ? enums
                            ? (() => {
                                const match = Object.keys(options).find(
                                    (key) =>
                                        String(options[key]) === String(value) // normalize type
                                );
                                return match ? camelToTitle(match) : "--Please Select--";
                            })()
                            : options[String(value)] || "--Please Select--"
                        : "--Please Select--"}
                </div>

                {/* Only render options list if not disabled */}
                {!disabled && isOpen && (
                    <div
                        className="position-absolute w-100 bg-white border rounded shadow-sm mt-1 pb-2"
                        style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto" }}
                    >
                        {isSearch && (
                            <div className="search-wrapper bg-white p-2 sticky-top">
                                <SearchInput
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder={searchPlaceholder}
                                    className="mb-4"
                                    isSearchStyle={true}
                                />
                            </div>
                        )}

                        {/* Disabled placeholder option */}
                        <div
                            className="px-3 pt-2 text-muted fs-md pb-1"
                            style={{
                                cursor: "not-allowed",
                                background: "transparent"
                            }}
                        >
                            --Please Select--
                        </div>

                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((key) => (
                                <div
                                    key={key}
                                    className="px-3 select-options fs-md"
                                    style={{
                                        cursor: "pointer",
                                        background:
                                            String(enums ? options[key] : key) === String(value)
                                                ? "rgba(var(--bs-primary-rgb), 0.30)"
                                                : "transparent"
                                    }}
                                    onClick={() =>
                                        handleSelect(enums ? options[key] : key)
                                    }
                                >
                                    {enums ? camelToTitle(key) : options[key]}
                                </div>
                            ))
                        ) : (
                            <div className="px-3 py-2 text-muted fs-md">
                                No results found
                            </div>
                        )}
                    </div>
                )}
            </div>

            {error && (
                <div
                    className={`form-text text-start text-danger w-100${
                        inline && label ? " offset-md-4" : ""
                    }`}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

export default SelectOption;
